import styled, { css } from "styled-components";

export const Title = styled.h1`
    font-weight: 600;
    font-size: 36px;
`;

export const Subitle = styled.h1`
    font-weight: 600;
    font-size: 24px;
`;

export const Image = styled.img`
    display: block;
    margin-left: auto;
    margin-right: 0;
    width: 70%;
`;

export const LightBg = styled.div`
    font-family: Inter;
    padding: 75px 125px;
    background: #FFFFFF;
`;

export const ParentCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 50px;
    margin-bottom: 50px;
    gap: 1rem;
`;

export const HorizontalBar = styled.div`
    width: 100%;
    height: 3px;
    margin: 20px 0px 20px 0px;
    grid-column: 1 / span 3;
    z-index: 1;

    background: #ffffff;

    @media screen and (max-width: 1180px) {
      grid-column: 1 / span 1;
    }
  }
`;

export const Pagination = styled.section`
    display: flex;
    justify-content: center;
`;

export const PaginationButton = styled.p`
    position: relative;
    width: 30px;
    padding: 1px;
    font-size: 16px;
    font-weight: 500;
    height: 32.5px;
    margin: 0 4px;
    text-align: center;
    color: #6554C0;
    user-select: none;
    border: 2px solid #DADADA;
    border-radius: 5px;

    &:hover {
        cursor: pointer;
        background: #DADADA;
        color: #6554C0;
        transition: 0.3s ease-out;
    }
    @media screen and (max-width: 500px) {
        width: 30px;
        height: 30px;
        font-size: 16px;
        margin: 0 2px;
    }
    ${(props) =>
        props.active &&
        css`
          background: #6554C0;
          color: #DADADA;
        //   border-radius: 10%;
        `}
    
      ${(props) =>
        props.unshow &&
        css`
          display: none;
        `}
    
`;
export const CustomStyle = {
  indicatorSeparator: () => {},
  dropdownIndicator: (defaultStyles) => ({
    ...defaultStyles,
    color: "#6554C0",
  }),
  control: (css) => ({
    ...css,
    background: "#FFFFFF",
    padding: "0px 10px",
    width: "170px",
    height: "100%",
    caretColor: "#6554C0",
    borderRadius: "5px",
    border: "1px solid #6554C0",
    cursor: "pointer",
    boxShadow: "none",
    "@media only screen and (max-width: 780px)": {
      ...CustomStyle["@media only screen and (max-width: 780px)"],
      width: "130px",
      paddingLeft: "8px",
    },
    "@media only screen and (max-width: 475px)": {
      ...CustomStyle["@media only screen and (max-width: 475px)"],
      width: "130px",
      fontSize: "13px",
    },
  }),

  option: (styles) => {
    return {
      ...styles,
      cursor: "pointer",
      "@media only screen and (max-width: 475px)": {
        ...styles["@media only screen and (max-width: 475px)"],
        fontSize: "13px",
      },
    };
  },
  singleValue: (styles) => ({
    ...styles,
    color: "#6554C0",
  }),
};




  